import { render, staticRenderFns } from "./c_player_registInfo.vue?vue&type=template&id=65de12d2&scoped=true&"
import script from "./c_player_registInfo.vue?vue&type=script&lang=js&"
export * from "./c_player_registInfo.vue?vue&type=script&lang=js&"
import style0 from "./c_player_registInfo.vue?vue&type=style&index=0&id=65de12d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de12d2",
  null
  
)

export default component.exports